import { updateDeepState } from '../../../handlers'
import { DISPLAY_TRACKING_USER_INFO, UPDATE_TRACKING_USER_INFO } from '../../../types/conversations/plugins'

const initialTrackingUserInfo = {
  isOpen: false,
  isLoading: false,
  isEmpty: true,
  trackingInfo: {
    user: {
      visits: 0,
      name: '',
      phone: '',
      email: '',
    },
    browsing: {
      ip: '',
      location: '',
      device: '',
      osInfo: '',
      browser: '',
    },
    variables: []
  }
}

export default function trackingUserInfo(state = updateDeepState(initialTrackingUserInfo), action) {
  switch (action.type) {
    case DISPLAY_TRACKING_USER_INFO: {
      const { isOpen, isLoading } = action
      return Object.assign({}, state, { isOpen, isLoading })
    }
    case UPDATE_TRACKING_USER_INFO: {
      const { trackingInfo, isEmpty } = action
      return Object.assign({}, state, { isLoading: false, trackingInfo, isEmpty })
    }
    default: {
      return state
    }
  }
}
